export const EVENT_MAP_ID = 'listings-root__event-location-map';
export const DEFAULT_ZOOM = 13;
